import React, { useState } from 'react';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { Button } from '../../../../../components/ui';
import MessageHeaderBlock from './MessageHeaderBlock';
import FormattedText from './FormattedText';
import { INTERVENE_AUTOMATION_COPY } from '../../../constants/interveneAutomationCopy';
import { useInterveneAutomation } from '../../../context/InterveneAutomationContext';
import useMessageStyles from '../../../hooks/useMessageStyles';
import { useMessageBubbleContext } from './MessageBubbleContext';

export default function ListMessage({ message }) {
  const {
    messageActionButtonSx,
    messageActionButtonPausedSx,
    messageFooterSx,
    messageOptionCardSx,
    messageOptionTitleSx,
    messageOptionDescriptionSx,
    automationPausedHintSx,
  } = useMessageStyles();
  const { isAutomationPaused } = useInterveneAutomation();
  const { isMine } = useMessageBubbleContext();
  const [showOptions, setShowOptions] = useState(false);
  const { header, text, footer, listTitle, listOptions } = message;
  const hasOptions = listOptions?.length > 0;

  const listButton = (
    <Button
      variant="outline"
      size="sm"
      disabled={isAutomationPaused}
      onClick={() => setShowOptions((prev) => !prev)}
      sx={{
        ...messageActionButtonSx,
        ...(isAutomationPaused ? messageActionButtonPausedSx : {}),
        flex: '0 0 auto',
        width: 'auto',
        minWidth: 120,
        maxWidth: '100%',
        ...(showOptions ? { mb: 0.75 } : null),
      }}
    >
      {showOptions ? 'Hide list' : `View ${listTitle || 'Options'}`}
    </Button>
  );

  return (
    <Box>
      <MessageHeaderBlock header={header} />
      <FormattedText text={text} sx={{ mb: hasOptions ? 0.75 : 0 }} />

      {hasOptions && (
        <>
          {isAutomationPaused ? (
            <Tooltip title={INTERVENE_AUTOMATION_COPY.automation.listPausedTooltip} arrow placement="top">
              <Box component="span" sx={{ display: 'inline-flex' }}>
                {listButton}
              </Box>
            </Tooltip>
          ) : (
            listButton
          )}

          {showOptions && !isAutomationPaused && (
            <Stack spacing={0.75} sx={{ mt: 0.75 }}>
              {listOptions.map((option, index) => (
                <Box
                  key={option.id || option.title || index}
                  data-inverted-surface={isMine ? 'true' : undefined}
                  sx={messageOptionCardSx}
                >
                  <Typography component="div" sx={messageOptionTitleSx}>
                    {option.title}
                  </Typography>
                  {option.description ? (
                    <Typography
                      component="div"
                      data-inverted-meta={isMine ? 'true' : undefined}
                      sx={messageOptionDescriptionSx}
                    >
                      {option.description}
                    </Typography>
                  ) : null}
                </Box>
              ))}
            </Stack>
          )}

          {isAutomationPaused ? (
            <Typography sx={{ ...automationPausedHintSx, mt: 0.5 }}>
              {INTERVENE_AUTOMATION_COPY.automation.customerActionsPaused}
            </Typography>
          ) : null}
        </>
      )}

      {footer && (
        <Typography variant="caption" sx={messageFooterSx}>
          {footer}
        </Typography>
      )}
    </Box>
  );
}
